import script from "./recommendSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./recommendSection.vue?vue&type=script&lang=ts&setup=true"

import "./recommendSection.vue?vue&type=style&index=0&id=fb31fb56&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb31fb56"]])

export default __exports__